import React from 'react';

import RichText from '../../../Global/RichText';

import styled from 'styled-components';

import { TITLE } from '../../../../utils/ES/About/index';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const AboutUsContainer = styled.div`
  padding: 110px 0px;
  text-align: center;
  max-width: 962px;
  width: 100%;

  margin: 0 auto;

  @media (max-width: ${breakpoints.mobile}) {
    padding: 20px 0px;
  }

  p {
    padding: 0 64px;

    @media (max-width: ${breakpoints.mobile}) {
      padding: 0;
    }
  }
`;

const AboutUs = () => {
  return (
    <>
      <div className="container">
        <AboutUsContainer>
          <RichText dataText={TITLE} />
        </AboutUsContainer>
      </div>
    </>
  );
};

export default AboutUs;
